import { Injectable } from '@angular/core';
import { ConfigurationService } from './configuration.service';

/**
 * Вспомогательный класс для построения ссылок
 * к ParticipantOffers.
 */
@Injectable({
  providedIn: 'root'
})
export class ParticipantOffersUrlBuilderService {
  constructor(private _configurationService: ConfigurationService) {}

  protected addBaseUrl(url: string, baseUrl: string): string {
    return baseUrl
      ? `${this._configurationService.configuration.links[baseUrl]}${url}`
      : url;
  }

  /**
   * Возвращает полный путь для вызова метода API ParticipantOffers.
   * @param relativePath - относительная ссылка на метод
   */
  public getAbsoluteUrl(relativePath: string): string {
    const baseUrl = this._configurationService.configuration.links.participantOffersBaseUrl;
    return `${baseUrl}${relativePath}`;
  }

  /**
   * Возвращает полный путь для вызова метода API TenderPlatform.
   * @param relativePath - относительная ссылка на метод
   */
  public getTenderPlatformAbsoluteUrl(relativePath: string): string {
    const baseUrl = this._configurationService.configuration.links.tenderPlatformBaseUrl;
    return `${baseUrl}${relativePath}`;
  }
  /**
   * Возвращает полный путь для вызова метода API FKS.
   * @param relativePath - относительная ссылка на метод
   */
  public getAbsoluteFksUrl(relativePath: string): string {
    const baseUrl = this._configurationService.configuration.links.fcsBaseUrl;
    return `${baseUrl}${relativePath}`;
  }
  /**
   * Возвращает полный путь для вызова метода Tender Platform Events API.
   * @param relativePath - относительная ссылка на метод
   */
  public getAbsoluteTenderPlatformEventsUrl(relativePath: string): string {
    const baseUrl = this._configurationService.configuration.links.tenderPlatformBaseUrl;
    return `${baseUrl}${relativePath}`;
  }
  /**
   * Возвращает query string параметры из объекта
   * @param params - параметры в виде объекта
   */
  public formatToQueryString(params: Object): string {
    return `?${Object.keys(params)
      .map((key) => `${key}=${params[key]}`)
      .join('&')}`;
  }
}
